import CloseIcon from '@mui/icons-material/Close';
import { Dispatch, SetStateAction } from 'react';

import * as S from './styles';

type VerificationWarningBoxProps = {
  errorTitle: 'credentials' | 'verification' | 'registeredEmail';
  messageTitle: 'credentials' | 'verification' | 'registeredEmail';
  setCodeIsWrong: Dispatch<SetStateAction<boolean>>;
};

export const VerificationWarningBox = ({
  setCodeIsWrong,
  errorTitle,
  messageTitle
}: VerificationWarningBoxProps) => {
  const error = {
    credentials: 'Email ou senha não conferem',
    verification: 'O código informado é inválido',
    registeredEmail: 'Usuário com esse email já existe'
  };

  const message = {
    credentials: (
      <S.Message>
        Se você usou o <strong>Google</strong> ou <strong>Facebook</strong>,
        tente fazer o login com estas formas voltando no navegador ou tentando
        recuperar a sua senha.
      </S.Message>
    ),
    verification: (
      <S.Message>
        Confirme se os dados que você passou conferem ou se o código recebido
        está correto.
      </S.Message>
    ),
    registeredEmail: (
      <S.Message>
        Se você usou o <strong>Google</strong> ou <strong>Facebook</strong>,
        tente fazer o login com estas formas voltando no navegador ou tentando
        fazer o login com email e senha.
      </S.Message>
    )
  };

  return (
    <S.LoginErrorContainer>
      <div>
        <S.Title>{error[errorTitle]}</S.Title>
        {message[messageTitle]}
      </div>
      <button
        style={{ border: 'none', background: 'transparent' }}
        onClick={e => {
          e.preventDefault();
          setCodeIsWrong(false);
        }}
      >
        <CloseIcon sx={{ fontSize: '24px', color: 'white' }} />
      </button>
    </S.LoginErrorContainer>
  );
};
